module.exports = __webpack_public_path__ + "media/packs/images/flags/KP-9044609e35c030bda39d4f01f090a387.png";